/* Temporizador de oferta de la ficha de producto.

   El plazo se guarda en localStorage, asi que baja de verdad mientras el
   cliente navega y no se reinicia en cada recarga. Al llegar a cero, si el
   ajuste "reiniciar" esta activo, arranca otro ciclo. */

class OfertaTemporizador extends HTMLElement {
  constructor() {
    super();
    this.duracion =
      (parseInt(this.dataset.horas, 10) || 0) * 3600 +
      (parseInt(this.dataset.minutos, 10) || 0) * 60;
    this.reiniciar = this.dataset.reiniciar === 'true';
    this.clave = `oferta:fin:${this.dataset.clave || 'global'}`;
    this.campos = {
      h: this.querySelector('[data-h]'),
      m: this.querySelector('[data-m]'),
      s: this.querySelector('[data-s]'),
    };
    this.intervalo = null;
  }

  connectedCallback() {
    if (this.duracion <= 0) {
      this.hidden = true;
      return;
    }
    this.pinta();
    this.intervalo = setInterval(() => this.pinta(), 1000);
  }

  disconnectedCallback() {
    if (this.intervalo) clearInterval(this.intervalo);
  }

  get fin() {
    const guardado = parseInt(localStorage.getItem(this.clave), 10);
    if (guardado && guardado > Date.now()) return guardado;
    return this.nuevoCiclo();
  }

  nuevoCiclo() {
    const fin = Date.now() + this.duracion * 1000;
    try {
      localStorage.setItem(this.clave, String(fin));
    } catch (e) {
      /* navegacion privada: el contador funciona igual, solo no persiste */
    }
    return fin;
  }

  pinta() {
    let restante = Math.floor((this.fin - Date.now()) / 1000);

    if (restante <= 0) {
      if (!this.reiniciar) {
        this.hidden = true;
        if (this.intervalo) clearInterval(this.intervalo);
        return;
      }
      restante = Math.floor((this.nuevoCiclo() - Date.now()) / 1000);
    }

    const h = Math.floor(restante / 3600);
    const m = Math.floor((restante % 3600) / 60);
    const s = restante % 60;
    const dosCifras = (n) => String(n).padStart(2, '0');

    if (this.campos.h) this.campos.h.textContent = dosCifras(h);
    if (this.campos.m) this.campos.m.textContent = dosCifras(m);
    if (this.campos.s) this.campos.s.textContent = dosCifras(s);

    this.classList.toggle('is-ultima-hora', restante <= 3600);
    this.setAttribute('aria-label', `La oferta termina en ${h} horas, ${m} minutos y ${s} segundos`);
  }
}

if (!customElements.get('oferta-temporizador')) {
  customElements.define('oferta-temporizador', OfertaTemporizador);
}

/* La barra viaja con el encabezado fijo: cuando el tema lo oculta al bajar,
   la barra sube con el; cuando reaparece al subir, la barra vuelve con el. */

function enlazaBarraConEncabezado() {
  const barra = document.querySelector('.barraof-seccion');
  const cabecera = document.querySelector('.section-header');
  if (!barra || !cabecera) return;

  const sincroniza = () => {
    const fija = cabecera.classList.contains('shopify-section-header-sticky');
    const oculta = cabecera.classList.contains('shopify-section-header-hidden');
    barra.classList.toggle('barraof--fija', fija);
    barra.classList.toggle('barraof--oculta', fija && oculta);
    barra.classList.toggle('barraof--anima', cabecera.classList.contains('animate'));
  };

  new MutationObserver(sincroniza).observe(cabecera, {
    attributes: true,
    attributeFilter: ['class'],
  });
  sincroniza();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enlazaBarraConEncabezado);
} else {
  enlazaBarraConEncabezado();
}
